import {
  DEFAULT_EXPANDED_SEARCH_RESULT_SECTIONS,
  type ExpandedSearchResultSectionType,
} from "./ExpandedSearchResultSections"
import type { ExpandedSearchResultAccountItem } from "./results/ExpandedSearchAccountResult"
import type { ExpandedSearchResultCollectionItem } from "./results/ExpandedSearchCollectionResult"
import type { ExpandedSearchResultCurrencyItem } from "./results/ExpandedSearchCurrencyResult"
import type { ExpandedSearchResultItem } from "./results/types"

export function getSectionsFromQuery(
  query: string,
): ExpandedSearchResultSectionType[] {
  const initialSections = new Set<ExpandedSearchResultSectionType>()

  // ENS / unstoppable domains
  if (query.endsWith(".eth") || query.endsWith(".crypto")) {
    initialSections.add("account")
    initialSections.add("item")
  }

  // Address
  if (query.startsWith("0x")) {
    initialSections.add("account")
    initialSections.add("currency")
  }

  // Currency
  if (query.startsWith("$") || query.toLocaleLowerCase().startsWith("anime")) {
    initialSections.add("currency")
  }

  return Array.from(
    new Set([
      ...Array.from(initialSections),
      ...DEFAULT_EXPANDED_SEARCH_RESULT_SECTIONS,
    ]),
  )
}

type SearchResults = {
  collections: ExpandedSearchResultCollectionItem[]
  currencies: ExpandedSearchResultCurrencyItem[]
  items: ExpandedSearchResultItem[]
  accounts: ExpandedSearchResultAccountItem[]
}

export function combineSearchResults(
  results: SearchResults,
  sections: ExpandedSearchResultSectionType[],
) {
  return sections.flatMap(section => {
    switch (section) {
      case "collection":
        return results.collections
      case "currency":
        return results.currencies
      case "item":
        return results.items
      case "account":
        return results.accounts
    }
  })
}
